import { Button } from '@economic/taco';
import { Trans } from '@lingui/macro';
import useSWRMutation from 'swr/mutation';
import { Form } from '~/app/shared/components/Form';
import { CreateCompanyRequestBody } from '../../types';

export const BankAccountStep = ({ handleNext }: { handleNext: () => void }) => {
    const createCompany = async (url: string, { arg }: { arg: { company: CreateCompanyRequestBody } }) => {
        if (arg.company !== undefined) {
            try {
                // TODO Will be done on EC-66499
                // await payrollApiClient.post(url, arg.company, { timeout: 10000 });
            } catch (error) {
                // console.error('Error creating company:', error);
            }
        }
    };

    const { trigger: triggerCompanyCreation } = useSWRMutation('/companies/create', createCompany);

    const onSubmit = () => {
        const companyToCreate: CreateCompanyRequestBody = {} as CreateCompanyRequestBody;

        // TODO: Populate companyToCreate with actual data from the form
        // Will be done on EC-66499
        triggerCompanyCreation({ company: companyToCreate }).finally(() => {
            handleNext();
        });
    };

    return (
        <>
            <h1 className="text-3xl mb-4 text-center">
                <Trans>Set up your bank account</Trans>
            </h1>
            <Form
                onSubmit={onSubmit}
                initialData={{}}
                key="payroll-onboarding-step3-form"
                skipNotifications
                validationSchema={undefined}>
                <div className="flex w-full justify-end">
                    <Button type="submit" appearance="primary">
                        <Trans>Next</Trans>
                    </Button>
                </div>
            </Form>
        </>
    );
};
